export default "__VITE_ASSET__B$gYuZgE__"